"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNBIND_URL = exports.UNBIND_PHONE_URL = exports.SERVICE_DATA = exports.MOBILE_STATUS_MAP = exports.MOBILE_STATUS = exports.LOGIN_STATUS = exports.LOCK_URL = exports.LOCK_UNBIND_URL = exports.LOCK_BIND_URL = exports.BIND_VERIFY_URL = exports.BIND_CHANGE_URL = exports.ACCOUNT_TYPE = void 0;
var _MOBILE_STATUS_MAP;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/*
 * @Author: liujunhong
 * @Date: 2022/10/21
 * @Desc:
 */
// 认证状态
var MOBILE_STATUS = {
  unbind: 'Unbind',
  bind: 'Bind',
  authing: 'Authing',
  authFinish: 'AuthFinish'
};
// 手机状态
exports.MOBILE_STATUS = MOBILE_STATUS;
var MOBILE_STATUS_MAP = (_MOBILE_STATUS_MAP = {}, _defineProperty(_MOBILE_STATUS_MAP, MOBILE_STATUS.unbind, '未绑定手机'), _defineProperty(_MOBILE_STATUS_MAP, MOBILE_STATUS.bind, '尚未认证手机'), _defineProperty(_MOBILE_STATUS_MAP, MOBILE_STATUS.authing, '处于验证期'), _MOBILE_STATUS_MAP);
// 未绑定url
exports.MOBILE_STATUS_MAP = MOBILE_STATUS_MAP;
var UNBIND_URL = '//security.gyyx.cn/MobilePhone/index';
// 认证
exports.UNBIND_URL = UNBIND_URL;
var BIND_VERIFY_URL = '//security.gyyx.cn/MobilePhone/VerifyRegisterInfo';
// 解绑
exports.BIND_VERIFY_URL = BIND_VERIFY_URL;
var UNBIND_PHONE_URL = '//security.gyyx.cn/MobilePhone/UnBindPhone';
// 绑定更换
exports.UNBIND_PHONE_URL = UNBIND_PHONE_URL;
var BIND_CHANGE_URL = '//security.gyyx.cn/MobilePhone/Change';
// 光宇乾坤锁
exports.BIND_CHANGE_URL = BIND_CHANGE_URL;
var LOCK_URL = '//security.gyyx.cn/EkeyV2/AjaxIsEkey';
// 乾坤锁未绑定
exports.LOCK_URL = LOCK_URL;
var LOCK_UNBIND_URL = '//security.gyyx.cn/EkeyV2/BindMain';
// 乾坤锁绑定
exports.LOCK_UNBIND_URL = LOCK_UNBIND_URL;
var LOCK_BIND_URL = '//security.gyyx.cn/EkeyV2/Index/';
exports.LOCK_BIND_URL = LOCK_BIND_URL;
var ACCOUNT_TYPE = 'custom';
// 登录状态
exports.ACCOUNT_TYPE = ACCOUNT_TYPE;
var LOGIN_STATUS = {
  IMPERFECT: 'SimpleRegisterUser' // 补充三项
};
// 服务
exports.LOGIN_STATUS = LOGIN_STATUS;
var SERVICE_DATA = [{
  title: '账号管理',
  url: '//account.gyyx.cn/'
}, {
  title: '充值',
  url: '//pay.gyyx.cn/'
},
// { title: '推广', url: '//extend.gyyx.cn/' },
{
  title: '兑换',
  url: '//change.gyyx.cn/'
}, {
  title: '安全',
  url: '//security.gyyx.cn'
}, {
  title: '客服',
  url: '//kf.gyyx.cn'
}, {
  title: '奇宝斋',
  url: '//qibao.gyyx.cn'
}];
exports.SERVICE_DATA = SERVICE_DATA;